import { Link, Text } from '@chakra-ui/react';
import appEnv from 'app/config/appEnv';

const S3_PUBLIC_BUCKET_URL = appEnv.VITE_S3_PUBLIC_BUCKET_URL;

const TERMS_AND_CONDITIONS_URL = `${S3_PUBLIC_BUCKET_URL}/terms_conditions.pdf`;
const PRIVACY_POLICY_URL = `${S3_PUBLIC_BUCKET_URL}/privacy_policy.pdf`;

/**
 * Terms and privacy links shown during employee sign-up. These point at the public documents in the
 * S3 public-data bucket — the same source the mobile app uses — because sign-up is unauthenticated
 * and the in-app footer pages sit behind the authenticated layout. Acceptance is recorded once
 * authentication completes, mirroring the mobile app.
 */
function SignUpLegalLinks() {
  return (
    <Text textStyle="extraSmallRegular" color="brand.mutedPurple" mb="20px">
      By continuing you agree to our{' '}
      <Link
        href={TERMS_AND_CONDITIONS_URL}
        isExternal
        color="brand.purple"
        textDecoration="underline"
      >
        Terms &amp; Conditions
      </Link>{' '}
      and{' '}
      <Link href={PRIVACY_POLICY_URL} isExternal color="brand.purple" textDecoration="underline">
        Privacy Policy
      </Link>
      .
    </Text>
  );
}

export default SignUpLegalLinks;
